import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  displayZeroSelector,
  hideDecimalsSelector,
  negativeMinusSelector,
} from '../userData/store/selectors';

import Numeral, { NumeralTypes, formatValue } from './numeral.component';

const FormatTypes = {
  DEFAULT: '0,0.[00000]',
  DECIMAL: '0,0.00',
  PERCENTAGE: '0.000000',
  PERCENT_4: '0.0000',
  PERCENT_2: '0.00',
};

const getFormat = type => {
  switch (type) {
    case NumeralTypes.DECIMAL:
      return FormatTypes.DECIMAL;
    case NumeralTypes.PERCENTAGE:
      return FormatTypes.PERCENTAGE;
    case NumeralTypes.PERCENT_2:
      return FormatTypes.PERCENT_2;
    case NumeralTypes.PERCENT_4:
      return FormatTypes.PERCENT_4;
    default:
      return FormatTypes.DEFAULT;
  }
};

const getFixedPrecision = type => {
  if (type === NumeralTypes.PERCENTAGE) {
    return '8';
  }

  if (type === NumeralTypes.PERCENT_4) {
    return '6';
  }

  return '2';
};

const CustomNumeral = ({
  children,
  shouldDisplayZero,
  type,
  additionalClassNames,
  hideDecimals,
  negativeMinus,
  suppressHidingDecimalPlaces,
}) => {
  const value = children || '0';

  if (!shouldDisplayZero && (value === '0' || value === '-')) {
    return (<span>-</span>);
  }

  const decimalFormat = hideDecimals && !suppressHidingDecimalPlaces ? '0,0' : getFormat(type);
  const decimalOrPercentageFormat
    = [NumeralTypes.PERCENTAGE, NumeralTypes.PERCENT_2, NumeralTypes.PERCENT_4].includes(type)
      ? `${decimalFormat}%`
      : decimalFormat;
  const customFormat = negativeMinus ? `-${decimalOrPercentageFormat}` : `(${decimalOrPercentageFormat})`;

  const fixedPrecision = hideDecimals && !suppressHidingDecimalPlaces ? '2' : getFixedPrecision(type);

  const parsedValue = formatValue({
    value,
    type,
    customFormat: customFormat.replace(/,/g, ''),
    fixedPrecision,
    acceptRaw: false,
  });

  if (!shouldDisplayZero && !isNaN(parsedValue) && !Number(parsedValue)) {
    return (<span>-</span>);
  }

  return (
    <Numeral
      customFormat={customFormat}
      fixedPrecision={fixedPrecision}
      type={type}
      additionalClassNames={additionalClassNames}
    >
      {value}
    </Numeral>
  );
};

CustomNumeral.propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  shouldDisplayZero: PropTypes.bool.isRequired,
  hideDecimals: PropTypes.bool.isRequired,
  negativeMinus: PropTypes.bool.isRequired,
  suppressHidingDecimalPlaces: PropTypes.bool,
  type: PropTypes.string,
  additionalClassNames: PropTypes.func,
};

CustomNumeral.defaultProps = {
  type: NumeralTypes.DECIMAL,
};

export default connect(state => ({
  shouldDisplayZero: displayZeroSelector(state),
  hideDecimals: hideDecimalsSelector(state),
  negativeMinus: negativeMinusSelector(state),
}))(CustomNumeral);
